/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { Box, Typography } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export function ServerStatusDialog(props) {
	const { open } = props;

	if (!open) {
		return null;
	}

	return (
		<Box
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				height: `${props.height}%`,
			}}
		>
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<CircularProgress style={{ height: '50px', width: '50px', margin: 'auto' }} />
				<Typography color="text.primary" variant="h5" sx={{mt: '40px'}}>
					<FormattedMessage id="Status.LoadingApp" defaultMessage="Loading ..." />
				</Typography>
			</div>
		</Box>
	);
}

ServerStatusDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	height: PropTypes.number
};

ServerStatusDialog.defaultProps = {
	height: 90
}

export default ServerStatusDialog;
